/**
 * openPage
 * 打开弹窗
 * @param options {object} 参数
 */
// eslint-disable-next-line no-unused-vars
function parentOpen(options, childWindow) {
  let config = {
    url: 'pages/tables/common.html',
    title: ' ',
    area: ['50%', '60%']
  }
  if (options) {
    // eslint-disable-next-line no-unused-vars
    config = Object.assign(config, options)
    if (!options.area && options.width && options.height) {
      if (typeof options.width == 'number' && typeof options.height == 'number') {
        config.area = [`${options.width}px`, `${options.height}px`]
        // eslint-disable-next-line no-dupe-else-if
      } else if (typeof options.width == 'string' && typeof options.height == 'string') {
        config.area = [options.width, options.height]
      }
    }
  }

  if (window.layerInitOk) {
    // eslint-disable-next-line no-undef
    let maxmin = typeof config.maxmin != 'undefined' ? config.maxmin : true
    if(!window.layer) return
    let index = window.layer.open({
      type: 2,
      title: config.title,
      maxmin: maxmin,
      area: config.area,
      content: config.url,
      cancel(index, layero){
        window.layer.close(index,() => {
          let findIndex = window.layerId.indexOf(index)
          if(findIndex>=0){
            window.layerId.splice(findIndex, 1);
            if(window.childWindowSuccess && window.childWindowSuccess.length && window.childWindowSuccess[findIndex]){
              //let callback = window.childWindowSuccess[findIndex];
              window.childWindow.splice(findIndex, 1);
              window.childWindowSuccess.splice(findIndex, 1);
              //callback(false);
            }
          }
        });
      },
      end() {
      },
      success: function(layero, index){
        //console.log(layero, index);
      }
    })
    if(!window.layerId){
      window.layerId = []
      window.childWindow = []
      window.childWindowSuccess = []
    }
    window.layerId.push(index)
    window.childWindow.push(childWindow)
    window.childWindowSuccess.push(config.success ? config.success : () => {})
  }
}

export default parentOpen
